import { ApiError } from '@/api/client'

/**
 * Plain language for anything a query or mutation can reject with. A raw
 * exception string is never shown to the user, so every failure path in this
 * feature goes through here.
 */
export function errorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (error instanceof ApiError) return error.message || fallback
  // fetch() rejects with a TypeError when the network itself failed.
  if (error instanceof TypeError) return 'Could not reach the server. Check your connection.'
  return fallback
}
